import GetShopArticleByIdRequestModelBase from '../_generated/modelBases/get-shop-article-by-id-request-model-base';

export default class GetShopArticleByIdRequestModel extends GetShopArticleByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
